import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "react-query",
  name: "reactQuery.name",
  description: "reactQuery.description",
  longDescription: "reactQuery.longDescription",
  category: "shared.categories.architecture",
  tags: "reactQuery.tags",
  featured: false,
  status: "coming-soon",
  architecture: "reactQuery.architecture",
  technologies: "reactQuery.technologies",
  concepts: "reactQuery.concepts",
  i18nNamespace: "reactQuery",
};
